// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// -- HS Code
import { environment } from '../../../environments/environment';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  // The values that are defined here are the default values that can
  // be overridden by env.js

  private _appSettings: { [id: string]: string } = {};

  public get clientId(): string {
    return this._appSettings['clientId'];
  }

  public get postLogoutRedirectUri(): string {
    return this._appSettings['postLogoutRedirectUri'];
  }

  public get redirectUri(): string {
    return this._appSettings['redirectUri'];
  }

  public get shouldCheckSession(): string {
    return this._appSettings['shouldCheckSession']
  }

  public get silentRenewUri(): string {
    return this._appSettings['silentRenewUri'];
  }

  public get surveyApiUrl(): string {
    return this._appSettings['surveyApiUrl'];
  }

  public get gtagPropertyId(): string {
    return this._appSettings['gtagPropertyId'];
  }

  public get idleTimeThreshold(): string {
    return this._appSettings['idleTimeThreshold'];
  }

  public get selfRegistration(): string {
    return this._appSettings['selfRegistration'];
  }

  public get openPacks(): string {
    return this._appSettings['openPacks'];
  }

  constructor() {
    this._appSettings['clientId'] = environment.authSettings.client_id;
    this._appSettings['postLogoutRedirectUri'] = environment.authSettings.post_logout_redirect_uri;
    this._appSettings['redirectUri'] = environment.authSettings.redirect_uri;
    this._appSettings['shouldCheckSession'] = environment.authSettings.startCheckSession.toString();
    this._appSettings['silentRenewUri'] = environment.authSettings.silent_renew_uri;
    this._appSettings['surveyApiUrl'] = environment.apiConfig.surveyApiUrl;

    this._appSettings['gtagPropertyId'] = environment.gtagPropertyId;
    this._appSettings['idleTimeThreshold'] = environment.idleTimeThreshold.toString();

    this._appSettings['selfRegistration'] = environment.featureToggle.selfRegistration
    this._appSettings['openPacks'] = environment.featureToggle.openPacks;
  }

  public setEnvValue(envName: string, envValue: string) {
    this._appSettings[envName] = envValue;
  }

  public getBoolean(envName: string): boolean {
    const envValue: string = this._appSettings[envName];
    if (!envValue) {
      throw Error("There is no environment setting matching the specified name");
    }

    const returnValue: boolean = envValue.toLowerCase() === 'true';
    return returnValue;
  }

  public getInt(envName: string): number {
    const envValue: string = this._appSettings[envName];
    if (!envValue) {
      throw Error("There is no environment setting matching the specified name");
    }

    const returnValue: number = parseInt(envValue);
    return returnValue;
  }
}
